

export const ParcelReceiptTemplate = `<div class="A4 water-mark water-mark-ie" style="padding-bottom: 0px;font-family: 'Cordia New';font-size: 26px;">
<div style="font-family: 'Cordia New';font-size: 26px;">
<h3 contenteditable="false" style="text-align: center;"><strong>ใบตรวจรับการจัดซื้อ/จัดจ้าง</strong></h3>

<div contenteditable="false" style="text-align: center;height:10px;"></div>
<div style="height:700px;">
    
    <p style="padding-left: 30px;padding-right: 30px;" contenteditable="true">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ตามหนังสือสัญญา/ข้อตกลง/ใบสั่ง 
    <span data-template="true" class="requisitioner" contenteditable="true" >เลขที่</span>
    <span data-template="true" contenteditable="true" >{po_no}</span> 
    <span data-template="true" class="requisitioner" contenteditable="true" >ลงวันที่</span>
    <span data-template="true" class="po_date" contenteditable="false" > {po_date} </span>
    <span data-template="true" contenteditable="true" > บริษัท ปตท. จำกัด (มหาชน) ได้ตกลงจัดซื้อจัดจ้างกับ </span>
    <span data-template="true" contenteditable="false" class="vendor_name">{vendor_name}</span> สำหรับ 
    <span data-template="true" contenteditable="true" >{po_header}</span> นั้น</p>
    
    <p style="padding-left: 30px;padding-right: 30px;" contenteditable="true">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;คู่สัญญาได้ส่งมอบ 
    <span data-template="true" contenteditable="true"> {po_header}</span>
    <span data-template="true" class="requisitioner" contenteditable="true"> งวดที่ </span>
    <span data-template="true" class="period" contenteditable="false">{period}</span>
    <span data-template="true" class="requisitioner" contenteditable="true"> เมื่อวันที่ </span>
    <span data-template="true" class="completed_date" contenteditable="false">{completed_date}</span> 
    
    <span data-template="true" contenteditable="true">&nbsp;โดย</span><span style="" contenteditable="true">{po_commitee_type}</span><span data-template="true" contenteditable="true">&nbsp;ได้ประชุมพิจารณาตรวจรับแล้วเมื่อวันที่&nbsp;</span><span style="text-align: center;" contenteditable="false" class="mom_date">{mom_date}</span><span data-template="true" contenteditable="true">&nbsp;ผลปรากฏว่า</span>
    </p>


    <p style="padding-left: 30px;" contenteditable="false">ผลการตรวจรับ</p>
    <p style="padding-left: 30px;" contenteditable="false"><input class="mycheckbox" type="checkbox" id="headercomplete" name="headercomplete" class="headercomplete" checked="true" /> ถูกต้อง</p>
    <p style="padding-left: 70px;" contenteditable="false"><input type="checkbox" id="completed" name="b_completed" class="b_completed" checked="true" /> ครบถ้วนตามสัญญา</p>
    <p style="padding-left: 70px;" contenteditable="false"><input type="checkbox" id="notcompleted" name="b_notcompleted" class="b_notcompleted" checked="false" /> ไม่ครบถ้วนตามสัญญา</p>
    <p style="padding-left: 30px;" contenteditable="false">&nbsp;&nbsp;&nbsp;&nbsp;ค่าปรับ</p>
    <p style="padding-left: 70px;" contenteditable="false"><input type="checkbox" id="fine" name="fine" class="b_fine" checked="true" /> มีค่าปรับ </p>
    <p style="padding-left: 70px;" contenteditable="false"><input type="checkbox" id="notfine" name="notfine" class="b_nofine" checked="" /> ไม่มีค่าปรับ</p>
</div>
<div style="height:140px;">
    <div style="display: flex;">
        <div style="width: 430px;float:left;" contenteditable="false">&nbsp;</div>
        <div style="width: 430px;text-align:center;padding-bottom:15px;float:left;"><span style="" contenteditable="true" >{po_commitee_type}</span></div>
    </div>
    <div style="display: flex;">
        <div style="width: 430px;float:left;">&nbsp;</div>
        <div style="width: 430px;text-align:center;float:left;"><span style="" contenteditable="true" > {po_header}</span></div>
    </div>
    <div style="display: flex;"></div>
</div>
<div><p style="padding-left: 30px;" contenteditable="false">Electronically approved by Acceptance Committee </p></div>
</div>
</div>
<div class="footer"></div>
`
export const Data={
    "mom_date" : "08/09/2564",
    "po_no" : "",
    "po_date" : "",
    "vendor_name" : "",
    "po_header" : "",
    "period" : "",
    "completed_date": "01/09/2564" ,
    "po_commitee_type": "คณะกรรมการตรวจรับสินค้า"
}

export const ValideData={
    "curent_date" : 1,
    "po_no" : 2,
    "po_date" : 1,
    "venor_name" : 1,
    "po_detail" : 1,
    "period" : 1,
    "completed_date": 1,
}

